import React from 'react';
import './Developer.css';
export default function Developer() {


    return (
        <p className='Developer'>
            Desarrollado por<a href='https://kexe.mx' target='_blank' rel='noreferrer'>Kexe</a>
        </p>
    );
}
